<template>
    <div>
        <el-dialog
            width="1030px"
            :append-to-body="true"
            :close-on-click-modal="false"
            class="regular-route-operate-dialog"
            :title="`${form.id ? '编辑' : '新增'}常跑线路`"
            :visible.sync="visible"
            :before-close="handleClose">
            <el-form
                :disabled="operationType === 'detail'"
                class="form-wrap"
                inline
                ref="form"
                :model="form"
                :rules="rules"
                label-width="145px"
                size="mini"
                style="font-size: 14px">
                <!-- <el-form-item label="线路名称" prop="routeName">
                <el-input v-model="form.routeName" placeholder="" :disabled="true"></el-input>
            </el-form-item> -->
                <div class="label">常跑/意向线路</div>
                <el-form-item label="线路类型" prop="routeType">
                    <el-select v-model="form.routeType" @change="handleTypeChange">
                        <el-option
                            v-for="(item, index) in typeOptions"
                            :key="index"
                            :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否零担自营线路" prop="isSelfManage">
                    <div class="flex">
                        <m-select
                            :value="form.isSelfManage"
                            @input="data => getSelectValue(data, 'isSelfManage')"
                            :optionNum="'SRM_YES_OR_NO'" />
                        <i v-if="form.id" @click="showRecord" class="el-icon-document"></i>
                    </div>
                    <div class="tips">注：零担发运场景，线路的始发档口、末端档口均为自营的，即为零担自营线路。</div>
                </el-form-item>
                <el-form-item label="始发地" prop="originProv" class="dialog-region-select">
                    <div>
                        <el-select
                            v-model="form.originProv"
                            clearable
                            @change="handleSelectChange($event, OPTION_TYPE[0], 0)"
                            filterable>
                            <el-option
                                v-for="(item, index) in originProvOptions"
                                :key="index"
                                :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                        <el-form-item label=" " label-width="0" prop="originCity" class="nobottom-form-item">
                            <el-select
                                v-model="form.originCity"
                                clearable
                                :disabled="!form.originProv"
                                @change="handleSelectChange($event, OPTION_TYPE[0], 1)"
                                filterable>
                                <el-option
                                    v-for="(item, index) in originCityOptions"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label=" " label-width="0" prop="originCounty" class="nobottom-form-item">
                            <el-select
                                v-model="form.originCounty"
                                :disabled="!form.originCity"
                                clearable
                                @change="handleSelectChange($event, OPTION_TYPE[0], 2)"
                                filterable>
                                <el-option
                                    v-for="(item, index) in originCountyOptions"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-form-item>
                <el-form-item label=" " >
                    <el-form-item label=" " label-width="0" prop="originStationName" class="nobottom-form-item station-item">
                        <el-input
                            class="station-name"
                            v-model="form.originStationName"
                            maxlength="100"
                            placeholder="始发地货站名称"></el-input>
                    </el-form-item>
                    <el-form-item label=" " label-width="0" prop="originAddress" class="nobottom-form-item">
                        <el-input
                            class="detail-address"
                            v-model="form.originAddress"
                            maxlength="100"
                            placeholder="始发地货站详细地址"></el-input>
                    </el-form-item>
                </el-form-item>
                <el-form-item label="目的地" prop="destinationProv" class="dialog-region-select">
                    <div>
                        <el-select
                            v-model="form.destinationProv"
                            clearable
                            @change="handleSelectChange($event, OPTION_TYPE[1], 0)"
                            filterable>
                            <el-option
                                v-for="(item, index) in destinationProvOptions"
                                :key="index"
                                :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                        <el-form-item label=" " label-width="0" prop="destinationCity" class="nobottom-form-item">
                            <el-select
                                v-model="form.destinationCity"
                                clearable
                                :disabled="!form.destinationProv"
                                @change="handleSelectChange($event, OPTION_TYPE[1], 1)"
                                filterable>
                                <el-option
                                    v-for="(item, index) in destinationCityOptions"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label=" " label-width="0" prop="destinationCounty" class="nobottom-form-item">
                            <el-select
                                v-model="form.destinationCounty"
                                clearable
                                :disabled="!form.destinationCity"
                                @change="handleSelectChange($event, OPTION_TYPE[1], 2)"
                                filterable>
                                <el-option
                                    v-for="(item, index) in destinationCountyOptions"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-form-item>
                <el-form-item label=" ">
                    <el-form-item label=" " label-width="0" prop="destinationStationName" class="nobottom-form-item station-item">
                        <el-input
                            class="station-name"
                            v-model="form.destinationStationName"
                            maxlength="100"
                            placeholder="目的地货站名称"></el-input>
                    </el-form-item>
                    <el-form-item label=" " label-width="0" prop="destinationAddress" class="nobottom-form-item">
                        <el-input
                            class="detail-address"
                            v-model="form.destinationAddress"
                            maxlength="100"
                            placeholder="目的地货站详细地址"></el-input>
                    </el-form-item>
                </el-form-item>
                <el-form-item label="始发地档口门头照片(带地址水印)" prop="originDoorFileList">
                    <multipleUpload :disabled="operationType==='detail'" :fileList="form.originDoorFileList" />
                    <div class="upload-tips">
                        零担自营线路必须上传始发地货站门头照。支持jpeg/png/jpg格式，单张图片不可超过3M，可同时选中上传多张图片，最多可传10张
                    </div>
                </el-form-item>
                <el-form-item label="始发地档口操作场照片(带地址水印)" prop="originOperateFileList">
                    <multipleUpload :disabled="operationType==='detail'" :fileList="form.originOperateFileList" />
                    <div class="upload-tips">
                        零担自营线路必须上传始发地档口操作场照片。支持jpeg/png/jpg格式，单张图片不可超过3M，可同时选中上传多张图片，最多可传10张
                    </div>
                </el-form-item>
                <el-form-item label="目的地档口门头照片(带地址水印)" prop="destinationDoorFileList">
                    <multipleUpload :disabled="operationType==='detail'" :fileList="form.destinationDoorFileList" />
                    <div class="upload-tips">
                        零担自营线路必须上传目的地货站门头照。支持jpeg/png/jpg格式，单张图片不可超过3M，可同时选中上传多张图片，最多可传10张
                    </div>
                </el-form-item>
                <el-form-item label="目的地档口操作场照片(带地址水印)" prop="destinationOperateFileList">
                    <multipleUpload :disabled="operationType==='detail'" :fileList="form.destinationOperateFileList" />
                    <div class="upload-tips">
                        零担自营线路必须上传目的地档口操作场照片。支持jpeg/png/jpg格式，单张图片不可超过3M，可同时选中上传多张图片，最多可传10张
                    </div>
                </el-form-item>

                <div class="label">其他信息</div>
                <el-form-item label="主发车型" prop="carType">
                    <m-select
                        :value="form.carType"
                        @input="data => getSelectValue(data, 'carType')"
                        :optionNum="'TMS_VEHICLE_BIG_TYPE'"
                        multiple />
                </el-form-item>
                <el-form-item label="是否有家电运输经验" prop="homeTransExp">
                    <MSelect
                        optionNum="SRM_YES_NO"
                        :value="form.homeTransExp"
                        @input="getSelectValue($event, 'homeTransExp')"></MSelect>
                </el-form-item>
                <el-form-item label="自有车数量" prop="carNum">
                    <el-input v-model="form.carNum" />
                </el-form-item>
                <el-form-item label="长期合作车数量" prop="cooperateCarNum">
                    <el-input v-model="form.cooperateCarNum" />
                </el-form-item>
                <el-form-item label="主要行业" prop="industryType">
                    <MSelect
                        :multiple="true"
                        :collapseTags="true"
                        optionNum="SRM_INDUSTRY_TYPE"
                        :value="form.industryType"
                        @input="getSelectValue($event, 'industryType')"></MSelect>
                </el-form-item>
                <el-form-item label="主要客户" prop="customer">
                    <el-input v-model="form.customer" />
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <template v-if="operationType !== 'detail'">
                    <el-button @click="handleClose">取 消</el-button>
                    <el-button type="primary" :loading="loading" @click="handleConfirm">确 定</el-button>
                </template>
                <el-button v-else type="primary" @click="handleClose">关闭</el-button>
            </span>
        </el-dialog>
        <editRecordDialog ref="editRecordRef" />
    </div>
</template>

<script>
import { getProvinces, getCitys, getDistricts } from '../../../../../../utils/getArea'
import { supplierCommonRouteAdd, supplierCommonRouteModify, supplierCommonRouteDetail, isNeedStationInfo } from '../../../../../../api/regularRoute.js'
import { supplierCommonRouteAddTemp } from '../../../../../../api/changeDetails.js';
import { dictWithUrl } from '@/components/lots/api'
import MSelect from '@/components/lots/otpSelect2'
import editRecordDialog from './editRecordDialog.vue'
import multipleUpload from './multipleUpload.vue'
import { cloneDeep } from 'lodash'
const INIT_FORM = {
    routeName: '',
    routeType: '',
    originProv: '',
    originProvName: '',
    originCity: '',
    originCityName: '',
    originCounty: '',
    originCountyName: '',
    destinationProv: '',
    destinationProvName: '',
    destinationCity: '',
    destinationCityName: '',
    destinationCounty: '',
    destinationCountyName: '',
    carType: [],
    homeTransExp: '',
    carNum: '',
    cooperateCarNum: '',
    industryType: [],
    customer: '',
    isSelfManage: '',
    originStationName: '',
    originAddress: '',
    destinationStationName: '',
    destinationAddress: '',
    originDoorFileList: [],
    originOperateFileList: [],
    destinationDoorFileList: [],
    destinationOperateFileList: [],
}
const OPTION_TYPE = ['origin', 'destination']
const OPTION_KEY = ['Prov', 'City', 'County']
const CHINA_CODE = '100000'
const CITY_ROUTE = '30'
const positiveIntegerVerify = new RegExp(/^[0-9]{1}\d{0,5}$/)
export default {
    name: 'Qualification',
    components: { MSelect, editRecordDialog, multipleUpload },
    props: {
        isSupplier: {
            type: Boolean,
            default: () => false,
        },
        supplierTab: {
            type: Object,
            default: () => {},
        },
    },
    // watch: {
    //     supplierTab() {
    //         this.search();
    //     }
    // },
    data() {
        return {
            OPTION_TYPE,
            OPTION_KEY,
            CITY_ROUTE,
            visible: false,
            form: cloneDeep(INIT_FORM),
            typeOptions: [
                // { label: '干线', value: '1' },
                // { label: '支线', value: '2' },
                // { label: '分配', value: '3' }
            ],
            originProvOptions: [],
            originCityOptions: [],
            originCountyOptions: [],
            destinationProvOptions: [],
            destinationCityOptions: [],
            destinationCountyOptions: [],
            loading: false,
            backupFormData: {},
            operationType: '',
            hasLessthan: false,
        }
    },
    computed: {
        districtVisible() {
            const { routeType, originCity, destinationCity } = this.form
            return (
                (this.isSupplier || (!this.isSupplier && this.typeOptions.length > 0 && routeType === CITY_ROUTE)) &&
                originCity &&
                originCity === destinationCity
            )
            // return false
        },
        rules(){
            return {
                routeType: [{ required: true, message: '请选择线路类型', trigger: ['change', 'blur'] }],
                originProv: [{ required: true, message: '请选择始发地省份', trigger: ['change', 'blur'] }],
                originCity: [{ required: true, message: '请选择始发地城市', trigger: ['change', 'blur'] }],
                originCounty: [{ required: this.form.routeType === '配送', message: '请选择始发地区县', trigger: ['change', 'blur'] }],
                destinationProv: [{ required: true, message: '请选择目的地省份', trigger: ['change', 'blur'] }],
                destinationCity: [{ required: true, message: '请选择目的地城市', trigger: ['change', 'blur'] }],
                destinationCounty: [{ required: this.form.routeType === '配送', message: '请选择目的地区县', trigger: ['change', 'blur'] }],
                carType: [{ required: true, message: '请选择主发车型', trigger: ['change', 'blur'] }],
                homeTransExp: [{ required: true, message: '请选择是否有家电运输经验', trigger: ['change', 'blur'] }],
                carNum: [
                    { required: true, message: '请输入自有车数量', trigger: ['change', 'blur'] },
                    {
                        pattern: positiveIntegerVerify,
                        message: '请输入6位正整数',
                        trigger: ['blur', 'change'],
                    },
                ],
                cooperateCarNum: [
                    { required: true, message: '请输入长期合作车数量', trigger: ['change', 'blur'] },
                    {
                        pattern: positiveIntegerVerify,
                        message: '请输入6位正整数',
                        trigger: ['blur', 'change'],
                    },
                ],
                industryType: [{ required: true, message: '请选择主要行业', trigger: ['change', 'blur'] }],
                isSelfManage: [{ required: true, message: '请选择是否零担自营线路', trigger: ['change', 'blur'] }],
                originStationName: [{ required: this.form.isSelfManage === '1' || this.hasLessthan, message: '请输入始发地货站名称', trigger: ['change', 'blur'] }],
                originAddress: [{ required: this.form.isSelfManage === '1' || this.hasLessthan, message: '请输入始发地货站详细地址', trigger: ['change', 'blur'] }],
                destinationStationName: [{ required: this.form.isSelfManage === '1' || this.hasLessthan, message: '请输入目的地货站名称', trigger: ['change', 'blur'] }],
                destinationAddress: [{ required: this.form.isSelfManage === '1' || this.hasLessthan, message: '请输入目的地货站详细地址', trigger: ['change', 'blur'] }],
                originDoorFileList: [{ required: this.form.isSelfManage === '1' || this.hasLessthan, message: '请上传始发地档口门头照片', trigger: ['change', 'blur'] }],
                originOperateFileList: [
                    { required: this.form.isSelfManage === '1' || this.hasLessthan, message: '请上传始发地档口操作场照片', trigger: ['change', 'blur'] },
                ],
                destinationDoorFileList: [{ required: this.form.isSelfManage === '1' || this.hasLessthan, message: '请上传目的地档口门头照片', trigger: ['change', 'blur'] }],
                destinationOperateFileList: [
                    { required: this.form.isSelfManage === '1' || this.hasLessthan, message: '请上传目的地档口操作场照片', trigger: ['change', 'blur'] },
                ],
            }
        },
    },
    methods: {
        showRecord() {
            this.$refs['editRecordRef'].open(this.form.id)
        },
        getSelectValue(v, prop) {
            this.form[prop] = v
            if(prop === 'isSelfManage'){
                this.$nextTick(() => {
                    this.$refs['form'].clearValidate()
                })
            }
        },
        clearStation(){
            //复制时清空货站相关字段
            this.form.originStationName = ''
            this.form.originAddress = ''
            this.form.destinationStationName = ''
            this.form.destinationAddress = ''
            this.form.originDoorFileList = []
            this.form.originOperateFileList = []
            this.form.destinationDoorFileList = []
            this.form.destinationOperateFileList = []
        },
        handleClose() {
            this.visible = false
            this.clear()
        },
        init(row, type) {
            this.visible = true
            this.operationType = type
            if (row) {
                if(['copy', 'supplement', 'detail'].includes(type)){
                    this.form = { 
                        ...row, 
                        industryType: row.industryType ? row.industryType.split(',') : [],
                        carType: row.carType ? row.carType.split(',') : [],
                    }
                    if(type === 'copy') this.clearStation()
                }else{
                    //编辑
                    supplierCommonRouteDetail({id: row.id}).then(res => {
                        if (res && +res.code === 0) {
                            this.form = {
                                ...res.data,
                                industryType: row.industryType ? row.industryType.split(',') : [],
                                carType: row.carType ? row.carType.split(',') : [],
                            }
                            this.backupFormData = cloneDeep(this.form)
                        }
                    })
                }
                
                getCitys(row.originProv).then(res => {
                    this.originCityOptions = res
                })
                if (row.originCity) {
                    getDistricts(row.originCity).then(res => {
                        this.originCountyOptions = res
                    })
                }
                getCitys(row.destinationProv).then(res => {
                    this.destinationCityOptions = res
                })
                if (row.destinationCity) {
                    getDistricts(row.destinationCity).then(res => {
                        this.destinationCountyOptions = res
                    })
                }
            }

            //查询所有业务类型的供应商是否存在承运商类别=零担专线
            let params = {supplierCode: this.supplierTab.supplierCode}
            if(type === 'supplement'){
                //承运商变更时填写，需要传transType
                params.transType = this.supplierTab.transType
            }
            isNeedStationInfo(params).then(res => {
                if (res && +res.code === 0) {
                    this.hasLessthan = res.data
                    this.$nextTick(() => {
                        this.$refs['form'].clearValidate()
                    })
                }
            })
        },
        handleVerify(callback) {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    callback()
                }
            })
        },
        handleConfirm() {
            this.handleVerify(() => {
                const params = {
                    ...this.form,
                    carType: this.form.carType + '',
                    industryType: this.form.industryType + '',
                    supplierCode: this.supplierTab.supplierCode,
                }
                if(this.form.id && this.form.isSelfManage === '1'){
                    //编辑&&零担自营线路=是，需要校验表单字段是否有变化,有变化则需要重新审批，否则不需要
                    params.needApproval = this.getDiff() ? '1' : '0'
                }
                this.loading = true
                if(this.operationType === 'supplement'){
                    supplierCommonRouteAddTemp(params)
                    .then(res => {
                        if (res && +res.code === 0) {
                            this.$emit('validate', params, res.data)
                            this.handleClose()
                        }
                    })
                    .finally(e => {
                        this.loading = false
                    })
                }else{
                    let api = this.form.id ? supplierCommonRouteModify : supplierCommonRouteAdd
                    api(params)
                    .then(res => {
                        this.loading = false
                        if (res && +res.code === 0) {
                            this.$message.success(`${this.form.id ? '编辑' : '新增'}成功`)
                            this.$emit('add')
                            this.handleClose()
                        }
                    })
                    .catch(e => {
                        this.loading = false
                    })
                }
            })
        },
        getDiff(){
            //表单字段是否有变化
            let formApproval = ['isSelfManage', 'routeType', 'originProv', 'originCity', 'originCounty', 'originStationName', 'originAddress', 'destinationProv', 'destinationCity', 'destinationCounty', 'destinationStationName', 'destinationAddress'].some(k => this.form[k] !== this.backupFormData[k])
            //图片是否有变化
            let fileApproval = ['originDoorFileList', 'originOperateFileList', 'destinationDoorFileList', 'destinationOperateFileList'].some(k => JSON.stringify(this.backupFormData[k].map(v => v.fileUrl)) !== JSON.stringify(this.form[k].map(v => v.fileUrl)))
            return formApproval || fileApproval
        },
        handleTypeChange(val) {
            if (val !== CITY_ROUTE) {
                this.form.originCounty = null
                this.form.destinationCounty = null
                this.form.originCountyName = null
                this.form.destinationCountyName = null
                // this.setName()
            }
        },
        handleSelectChange(val, type, keyIndex) {
            if (OPTION_KEY[keyIndex] === OPTION_KEY[0]) {
                this.form[type + OPTION_KEY[1]] = null
                this.form[type + OPTION_KEY[2]] = null
                getCitys(val).then(res => {
                    this[type + OPTION_KEY[1] + 'Options'] = res
                    this[type + OPTION_KEY[2] + 'Options'] = []
                })
            } else if (OPTION_KEY[keyIndex] === OPTION_KEY[1]) {
                this.form[type + OPTION_KEY[2]] = null
                getDistricts(val).then(res => {
                    this[type + OPTION_KEY[2] + 'Options'] = res
                })
            }
            if (type === 'origin' && keyIndex === 0) {
                //起始省份
                this.form.originProvName = val ? this.originProvOptions.find(v => v.value === val).label : ''
                this.form.originCityName = ''
                this.form.originCountyName = ''
            }
            if (type === 'origin' && keyIndex === 1) {
                //起始市
                this.form.originCityName = val ? this.originCityOptions.find(v => v.value === val).label : ''
                this.form.originCountyName = ''
            }
            if (type === 'origin' && keyIndex === 2) {
                //起始区
                this.form.originCountyName = val ? this.originCountyOptions.find(v => v.value === val).label : ''
            }
            if (type === 'destination' && keyIndex === 0) {
                //目的省份
                this.form.destinationProvName = val ? this.destinationProvOptions.find(v => v.value === val).label : ''
                this.form.destinationCityName = ''
                this.form.destinationCountyName = ''
            }
            if (type === 'destination' && keyIndex === 1) {
                //目的市
                this.form.destinationCityName = val ? this.destinationCityOptions.find(v => v.value === val).label : ''
                this.form.destinationCountyName = ''
            }
            if (type === 'destination' && keyIndex === 2) {
                //目的区
                this.form.destinationCountyName = val
                    ? this.destinationCountyOptions.find(v => v.value === val).label
                    : ''
            }
            // this.setName()
        },
        setName() {
            this.form.routeName = ''
            let startName = ''
            let endName = ''
            const { originCityOptions, originCountyOptions, destinationCityOptions, destinationCountyOptions } = this
            const { originCity, originCounty, destinationCity, destinationCounty, routeType } = this.form
            if (originCounty && destinationCounty) {
                startName =
                    originCityOptions.filter(option => option.value === originCity)[0].label +
                    originCountyOptions.filter(option => option.value === originCounty)[0].label
                endName =
                    destinationCityOptions.filter(option => option.value === destinationCity)[0].label +
                    destinationCountyOptions.filter(option => option.value === destinationCounty)[0].label
                this.form.routeName = startName + '-' + endName
            } else if (originCity && destinationCity && routeType !== CITY_ROUTE) {
                startName = originCityOptions.filter(option => option.value === originCity)[0].label
                endName = destinationCityOptions.filter(option => option.value === destinationCity)[0].label
                this.form.routeName = startName + '-' + endName
            }
        },
        clear() {
            this.form = cloneDeep(INIT_FORM)
            this.$nextTick(() => {
                this.$refs['form'].clearValidate()
            })
        },
    },
    mounted() {
        dictWithUrl('DC_ROUTE_TYPE').then(res => {
            if (res && +res.code === 0) {
                const typeObj = res.data.DC_ROUTE_TYPE
                this.typeOptions = Object.keys(typeObj).map(key => {
                    return { label: typeObj[key], value: key }
                })
            }
        })
        getProvinces(CHINA_CODE).then(res => {
            this.originProvOptions = res
            this.destinationProvOptions = res
        })
    },
}
</script>
<style lang="less">
.regular-route-operate-dialog {
    .form-wrap{
        width: 900px;
        margin: 0 auto;
    }
    .dialog-region-select {
        input {
            width: 130px;
            margin-right: 32px;
        }
        .el-input__suffix {
            right: 35px;
        }
    }
    .el-input-group,
    .el-date-editor,
    .otp-select,
    .advance-input,
    .address-select-container {
        width: 164px;
    }
    .nobottom-form-item {
        margin-bottom: 0;
        margin-right: 0;
    }
    .label {
        margin-bottom: 10px;
    }
    .tips {
        font-size: 10px;
        margin-left: -115px;
    }
    .flex {
        display: flex;
        align-items: center;
        .el-icon-document {
            margin-left: 10px;
            cursor: pointer;
        }
    }
    .station-name {
        width: 130px;
        margin-right: 32px;
    }
    .detail-address {
        width: 304px;
        input {
            width: 100%;
        }
    }
    .upload-tips {
        font-size: 12px;
        line-height: 34px;
        color: #aaa;
    }
    .station-item{
        .el-form-item__label{
            margin-left: -12px;
        }
    }
}
</style>
